import { ReactNode } from 'react';

const FormInputWrapper = ({
  id,
  footnote,
  description,
  text,
  children,
  toolTip,
  isRequired = false,
}: {
  id: string;
  footnote?: string | number;
  text: string;
  description?: string;
  children: ReactNode;
  toolTip?: ReactNode;
  isRequired?: boolean;
}) => {
  const renderTextWithAsterisk = (text: string) => (
    <span>
      {text}
      {isRequired && (
        <span className="text-utility-violet-600 font-normal ml-[2px]">*</span>
      )}
    </span>
  );

  return (
    <div className="flex flex-col gap-6">
      {description ? (
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <label
              htmlFor={id}
              className="text-base font-bold text-neutral-1 relative flex gap-2 items-center"
            >
              <div className="flex items-center gap-2">
                {renderTextWithAsterisk(text)}
                {toolTip}
              </div>
              {footnote && (
                <span className="text-xs font-medium text-neutral-2 align-super">
                  &nbsp;{footnote}
                </span>
              )}
            </label>
            <p className="body-15-regular text-neutral-2">{description}</p>
          </div>
          {children}
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <label
            htmlFor={id}
            className="text-base font-bold text-neutral-1 relative select-none"
          >
            <div className="flex items-center gap-2">
              {renderTextWithAsterisk(text)}
              {toolTip}
            </div>
            {footnote && (
              <span className="text-xs font-medium text-neutral-2 align-super">
                &nbsp;{footnote}
              </span>
            )}
          </label>
          {children}
        </div>
      )}
    </div>
  );
};

export default FormInputWrapper;
